import axios from 'axios'
import store from 'store'
import {mapNoticeItem, mapCourseItem} from 'utils/notices';
import { directDealApiHost } from 'config/env.conf';
// import qs from 'qs'

// 上线
export const online = (id) => axios.put(`/midas/mis/msc/deal/preprod/online?mtpDealId=${id}`);

// 从哥伦布拉取数据
export const pullData = (id, contractNum) => axios.get(`/midas/mis/msc/deal/preprod/resource/info?relationMtDealId=${id}&contractNum=${contractNum}`);

// 获取数据接口
export const get = (id) => axios.get(`/midas/mis/msc/deal/preprod/info?preProdId=${id}`);

// 新建
export const create = (data) => axios.post(`/midas/mis/preprod/tickets`, data);

// 更新
export const update = (data, id) => axios.put(`/midas/mis/preprod/tickets/${id}`, data);



// WEBPACK FOOTER //
// ./src/api/tuanTicket.js